class PasswordChanger {
  constructor(container) {
    if (container === null) return;
    if (container.tagName !== "FORM") return;
    this.container = container;
    this.init();
  }
  init() {
    this.oldPass = this.container.querySelector("#currentpass");
    if (this.oldPass === null) return;
    this.newPass = this.container.querySelector("#newpass");
    if (this.newpass === null) return;
    this.confirmPass = this.container.querySelector("#confirmpass");
    if (this.confirmpass === null) return;
    this.submitButton = this.container.querySelector(".udata__submit");
    if (this.submitButton === null) return;
    this.submitButton.disabled = true;
    this.container.addEventListener("input", this.onFormChange.bind(this));
  }
  onFormChange() {
    if (this.validate()) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }
  validate() {
    if (this.oldPass.value === "") return false;
    if (this.newPass.value === "") return false;
    if (this.confirmPass.value === "") return false;
    if (this.newPass.value !== this.confirmPass.value) return false;
    return true;
  }
}

export default PasswordChanger;



// WEBPACK FOOTER //
// ./src/js/components/passwordChanger.js